import * as React from 'react';

import { DataGrid } from '@mui/x-data-grid';

import {
	getPracticeStaff,
	updatePracticeStaff,
} from '../../../../services/api/apiManager';

import { useState, useEffect } from 'react';

import Tooltip from '@mui/material/Tooltip';
import Menu from '@mui/material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
	Alert,
	Snackbar,
	Box,
	Button,
	Grid,
	TextField,
	InputLabel,
	MenuItem,
	Modal,
	Select,
	Typography,
	IconButton,
	useMediaQuery,
	CircularProgress,
	InputAdornment,
} from '@mui/material';

import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';

import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';

import DialogTitle from '@mui/material/DialogTitle';

import Dialog from '@mui/material/Dialog';

import DialogContent from '@mui/material/DialogContent';

import { useTheme } from '@mui/material/styles';

import * as Yup from 'yup';

import CancelIcon from '@mui/icons-material/Cancel';
import dayjs from 'dayjs';
import { Call } from '@mui/icons-material';
import MaskedInput from 'react-text-mask';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '60%',
	backgroundColor: 'white',
	border: ' 1px solid #00000026',
	// p: 4,
	borderRadius: '10px',
};

function ViewStaff() {
	// Edit Delete Popover states and functions are here
	const [anchorED, setAnchorED] = React.useState(null);
	const editDelete_pop_opens = Boolean(anchorED);
	const handleClickED = (event, params) => {
		// i am opening my popover from here and also setting values of modals from here am setting delete and edit modal states data from here

		setModalValues(params?.row);
		//setting deleteModal Data
		setDeleteUser(params?.row?.Fname);
		setDeleteID(params?.row?.id);

		setAnchorED(event.currentTarget);
	};
	const handleCloseED = () => {
		setAnchorED(null);
	};

	// const [anchorEl, setAnchorEl] = React.useState(null);
	const [staffs, setStaffs] = useState([]);

	// Modal States
	const [openModal, setOpenModal] = useState(false);
	const [modalValues, setModalValues] = useState({});

	// Delete Data States
	const [deleteID, setDeleteID] = useState();
	const [deleteUser, setDeleteUser] = useState();
	// Loader State
	const [loading, setLoading] = useState(false);
	// Dialog States
	const theme = useTheme();
	const [dialogOpen, setDialogOpen] = React.useState(false);
	const [deletePopupOpen, setDeletePopupOpen] = React.useState(false);
	const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

	// Snackbar States
	const [severity, setSeverity] = useState('success'); // Default severity
	const [openSnackbar, setOpenSnackbar] = useState(false);
	// open snakbar
	const handleClickSnackbar = () => {
		setOpenSnackbar(true);
	};
	//   close Snackbar
	const handleCloseSnackbar = () => {
		setOpenSnackbar(false);
	};
	const schema = Yup.object().shape({
		Fname: Yup.string().matches(/^[a-zA-Z\s]+$/, 'Alphabets only'),
		Lname: Yup.string().matches(/^[a-zA-Z\s]+$/, 'Alphabets only'),
		Title: Yup.string().matches(/^[a-zA-Z\s]+$/, ' Alphabets only'),
		City: Yup.string().matches(/^[a-zA-Z\s]+$/, 'Alphabets only'),
		State: Yup.string().matches(
			/^[a-zA-Z]+$/,
			'Alphabets without blank spaces'
		),
		Specialty: Yup.string().matches(/^[a-zA-Z\s]+$/, ' Alphabets only'),
		Contact: Yup.string().matches(
			/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
			'Invalid '
		),
		NPI: Yup.string().matches(/^\d+$/, 'Numbers only '),
		Zip: Yup.string().matches(/^\d+$/, 'Numbers only '),
	});

	const [errors, setErrors] = useState({});

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setModalValues((prev) => ({
			...prev,
			[name]: value,
		}));

		Yup.reach(schema, name)
			.validate(value)
			.then(() => {
				setErrors((prevErrors) => ({
					...prevErrors,
					[name]: '', // Clear error if validation passes
				}));
			})
			.catch((error) => {
				setErrors((prevErrors) => ({
					...prevErrors,
					[name]: error.message, // Set error message if validation fails
				}));
			});
	};

	// Close Modal Function
	const handleCloseModal = () => {
		setOpenModal(false);
	};

	// Dialog Function
	const handleDialogClose = () => {
		setDialogOpen(false);
	};

	const deleteCancelPopup = () => {
		setDeletePopupOpen(false);
	};

	const handleDialogOpen = () => {
		setDialogOpen(true);
	};

	const fetchStaff = async () => {
		setLoading(true);
		try {
			const response = await getPracticeStaff();
			if (response?.status === 200) {
				setLoading(false);
				setStaffs(response?.data);
			} else {
				setStaffs([]);
			}
		} catch (error) {
			console.error('Error fetching Staff:', error);
		}
	};

	useEffect(() => {
		fetchStaff();
	}, []);

	// Function -- Target Modal Textfields Values
	const targetModalValue = (event) => {
		event.preventDefault();
		setModalValues({
			...modalValues,
			[event.target.name]: event.target.value,
		});
	};

	// Function -- Edit Data
	const handleEdit = () => {
		// Open the Modal
		setOpenModal(true);
	};

	// Function Update Modal Values -- Edit Functionality
	const updateModalValues = async (modalValues) => {
		if (
			errors?.Title ||
			errors?.Fname ||
			errors?.Lname ||
			errors?.City ||
			errors?.Contact ||
			errors?.NPI ||
			errors?.State ||
			errors?.Zip
		) {
		} else {
			const resp = await updatePracticeStaff(modalValues.id, modalValues);
			if (resp?.request?.status === 200) {
				setAnchorED(null);
				handleCloseModal();
				handleClickSnackbar();
				// Snackbar Color Show
				setSeverity('success');
				fetchStaff();
			} else {
				setLoading(false);
				setSeverity('error');
				handleClickSnackbar();
				// Snackbar Color Show
			}
		}
	};

	// Delete Object
	const deleteStatus = {
		Deleted: true,
	};
	// Function Delete Staff User
	const handleDeleteUser = () => {
		setDeletePopupOpen(true);
	};
	// Funtion For Delete Staff ID
	const deleteStaff = async (deleteID) => {
		const response = await updatePracticeStaff(deleteID, deleteStatus);

		if (response?.request?.status === 200) {
			setDeletePopupOpen(false);
			setAnchorED(null);
			setLoading(true);
			handleClickSnackbar();
			setSeverity('error');
			try {
				const newData = await fetchStaff();
				setLoading(false);
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		} else {
			setDeletePopupOpen(false);
			setLoading(false);
		}
	};

	const rows =
		staffs &&
		staffs.map((p) => ({
			id: p.id,
			Fname: p.Fname || '',
			Lname: p.Lname || '',
			UserName: p.Lname + ',' + p.Fname || '',
			Title: p.Title || '',
			Specialty: p.Specialty || '',
			Contact: p.Contact || '',
			Address: p.Address || '',
			Comments: p.Comments || '',
			//Dont'change DOB format because during Update API needs this format for updation
			DOB: dayjs(p.DOB).format('YYYY-MM-DD') || '',
			Gender: p.Gender || '',
			NPI: p.NPI || '',
			City: p.City || '',
			State: p.State || '',
			Zip: p.Zip || '',
		}));

	const columns = [
		// { field: 'id', headerName: 'Id', width: 40 },
		{ field: 'Title', headerName: 'Title', width: 80 },
		{ field: 'Fname', headerName: 'FirstName', width: 150 },
		{ field: 'Lname', headerName: 'LastName', width: 150 },
		{ field: 'DOB', headerName: 'DOB', width: 120 },
		{ field: 'Specialty', headerName: 'Speciality', width: 120 },
		{ field: 'NPI', headerName: 'NPI', width: 150 },
		{ field: 'Contact', headerName: 'Mobile', width: 150 },
		{ field: 'Address', headerName: 'Address', width: 276 },
		{
			sortable: false,
			disableColumnMenu: true,
			field: 'action',
			headerName: 'Action',
			description: 'This column has a value getter and is not sortable.',
			sortable: false,
			// renderCell: (params) => (
			// 	<>
			// 		<Tooltip title="Edit User">
			// 			<BorderColorOutlinedIcon
			// 				fontSize="small"
			// 				style={{ marginLeft: 5, cursor: 'pointer' }}
			// 				onClick={() => handleEdit(params)}
			// 			/>
			// 		</Tooltip>

			// 		<Tooltip title="Delete User">
			// 			<DeleteOutlinedIcon
			// 				fontSize="small"
			// 				style={{ marginLeft: 5, cursor: 'pointer', color: 'black' }}
			// 				onClick={() => handleDeleteUser(params)}
			// 			/>
			// 		</Tooltip>
			// 	</>
			// ),
			renderCell: (params) => {
				return (
					<div>
						<IconButton
							aria-label="more"
							id="long-button"
							aria-controls={editDelete_pop_opens ? 'long-menu' : undefined}
							aria-expanded={editDelete_pop_opens ? 'true' : undefined}
							aria-haspopup="true"
							onClick={(event) => {
								handleClickED(event, params);
							}}
						>
							<MoreVertIcon />
						</IconButton>
						<Menu
							sx={{ marginTop: '-1.5%' }}
							id="long-menu"
							anchorEl={anchorED}
							open={editDelete_pop_opens}
							onClose={handleCloseED}
							PaperProps={{
								style: {
									width: '83px',
									width: '72px',
									borderRadius: '7px',
									boxShadow: '0px 1px 10px 0px #00000040',
								},
							}}
						>
							<MenuItem onClick={() => handleEdit()} sx={{ fontSize: '14px' }}>
								Edit
							</MenuItem>
							<MenuItem
								onClick={() => handleDeleteUser()}
								sx={{ fontSize: '14px', color: '#ED2828' }}
							>
								Delete
							</MenuItem>
						</Menu>
					</div>
				);
			},
		},
	];

	// const open = Boolean(anchorEl);
	// const handleClick = (event) => {
	// 	setAnchorEl(event.currentTarget);
	// };
	// const handleClose = () => {
	// 	setAnchorEl(null);
	// };

	return (
		<div>
			{!loading && staffs?.length === 0 ? (
				<Box
					width={'100%'}
					height={'45vh'}
					display={'flex'}
					alignItems={'center'}
					justifyContent={'center'}
					color={'#ED2828'}
				>
					Add Staff to proceed !
				</Box>
			) : (
				''
			)}{' '}
			{loading ? (
				<Box
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: '80vh',
					}}
				>
					<CircularProgress />
				</Box>
			) : (
				<Box
					sx={{
						width: {
							xl: '100%',
							lg: '90%',
							md: '80%',
							sm: '80%',
							xs: '70%',
						},
						overflow: 'auto',
						height: '70vh',
					}}
				>
					{staffs?.length > 0 && (
						<DataGrid
							rows={rows}
							rowHeight={38}
							columnHeaderHeight={38}
							columns={columns}
							initialState={{
								pagination: { paginationModel: { pageSize: 10 } },
							}}
							pageSizeOptions={[10, 25, 50]}
							// checkboxSelection
							disableRowSelectionOnClick
							sx={{
								'& .MuiDataGrid-columnHeaders': {
									background: '#EEF5FFCC',
									color: '#333',
									fontFamily: 'Poppins',
									fontWeight: '600',
									fontSize: '15px',
								},
								'& .MuiDataGrid-footerContainer': {
									justifyContent: 'flex-end',
									backgroundColor: '#DCF0FFBA',
								},
							}}
						/>
					)}
					{/* Modal Structure Design */}
					<Modal
						open={openModal}
						// onClose={handleCloseModal}
						aria-labelledby="edit-modal-title"
						aria-describedby="edit-modal-description"
						sx={{
							'& .MuiModal-backdrop': {
								opacity: '3 !important',
							},
						}}
					>
						<Box sx={style}>
							<Grid container lg={12} xs={12} md={12} sm={12}>
								<Grid
									item
									lg={12}
									xs={12}
									md={12}
									sm={12}
									xl={12}
									justifyContent="center"
								>
									<Box
										sx={{
											width: '100%',
											height: '65px',
											display: 'flex',
											justifyContent: 'center',
											alignItems: 'center',
											borderBottom: '1px solid #00000070',
										}}
									>
										<Typography
											sx={{
												width: '88%',
												fontFamily: 'Poppins',
												fontSize: '32px',
												fontWeight: 500,
												textAlign: 'center',
											}}
										>
											Edit Staff
										</Typography>
										<IconButton onClick={handleCloseModal}>
											<CancelIcon sx={{ fontSize: '30px' }} color="error" />
										</IconButton>
									</Box>
								</Grid>
							</Grid>
							<Grid container lg={12} xs={12} md={12} sm={12} p={3}>
								<Grid
									item
									lg={4}
									xs={4}
									md={4}
									sm={4}
									sx={{ padding: '10px 5px' }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										Title<span style={{ color: '#d61b1b' }}>*</span>
									</InputLabel>
									<TextField
										name="Title"
										type="text"
										size="small"
										fullWidth
										disableUnderline
										value={modalValues?.Title}
										onChange={handleInputChange}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									/>
									{errors.Title && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.Title}
										</div>
									)}{' '}
									{/* Display validation error */}
								</Grid>
								<Grid
									item
									lg={4}
									xs={4}
									md={4}
									sm={4}
									sx={{ padding: '10px 5px' }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										First Name<span style={{ color: '#d61b1b' }}>*</span>
									</InputLabel>
									<TextField
										name="Fname"
										type="text"
										size="small"
										fullWidth
										disableUnderline
										value={modalValues?.Fname}
										onChange={handleInputChange}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									/>
									{errors.Fname && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.Fname}
										</div>
									)}{' '}
									{/* Display validation error */}
								</Grid>
								<Grid
									item
									lg={4}
									xs={4}
									md={4}
									sm={4}
									sx={{ padding: '10px 5px' }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										Last Name<span style={{ color: '#d61b1b' }}>*</span>
									</InputLabel>
									<TextField
										name="Lname"
										type="text"
										size="small"
										fullWidth
										disableUnderline
										value={modalValues?.Lname}
										onChange={handleInputChange}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									/>
									{errors.Lname && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.Lname}
										</div>
									)}{' '}
									{/* Display validation error */}
								</Grid>
								<Grid
									item
									lg={4}
									xs={4}
									md={4}
									sm={4}
									sx={{ padding: '10px 5px' }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										DOB<span style={{ color: '#d61b1b' }}>*</span>
									</InputLabel>
									<TextField
										name="DOB"
										type="date"
										size="small"
										fullWidth
										disableUnderline
										value={dayjs(modalValues?.DOB).format('YYYY-MM-DD')}
										onChange={targetModalValue}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
										error={
											modalValues?.DOB >= dayjs(new Date()).format('YYYY-MM-DD')
										}
										helperText={
											modalValues?.DOB >= dayjs(new Date()).format('YYYY-MM-DD')
												? '*Please Add Accurate DOB'
												: ''
										}
									/>
								</Grid>
								<Grid
									item
									lg={4}
									xs={4}
									md={4}
									sm={4}
									sx={{ padding: '10px 5px' }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										Speciality<span style={{ color: '#d61b1b' }}>*</span>
									</InputLabel>
									<TextField
										name="Specialty"
										type="text"
										size="small"
										fullWidth
										disableUnderline
										value={modalValues?.Specialty}
										onChange={handleInputChange}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									/>
									{errors.Specialty && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.Specialty}
										</div>
									)}{' '}
								</Grid>
								<Grid
									item
									lg={4}
									xs={4}
									md={4}
									sm={4}
									sx={{ padding: '10px 5px' }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										Gender<span style={{ color: '#d61b1b' }}>*</span>
									</InputLabel>
									<Select
										name="Gender"
										size="small"
										fullWidth
										displayEmpty
										inputProps={{ padding: '2px' }}
										value={modalValues?.Gender}
										onChange={targetModalValue}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									>
										<MenuItem value="">Select</MenuItem>
										<MenuItem value={'M'}>Male</MenuItem>
										<MenuItem value={'F'}>Female</MenuItem>
									</Select>
								</Grid>
								<Grid
									item
									lg={6}
									xs={6}
									md={6}
									sm={6}
									sx={{ padding: '10px 5px' }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										NPI<span style={{ color: '#d61b1b' }}>*</span>
									</InputLabel>
									<TextField
										name="NPI"
										type="text"
										size="small"
										fullWidth
										disableUnderline
										value={modalValues?.NPI}
										onChange={handleInputChange}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									/>
									{errors.NPI && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.NPI}
										</div>
									)}{' '}
									{/* Display validation error */}
								</Grid>
								<Grid
									item
									lg={6}
									xs={6}
									md={6}
									sm={6}
									sx={{ padding: '10px 5px' }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										Mobile<span style={{ color: '#d61b1b' }}>*</span>
									</InputLabel>
									<MaskedInput
										required
										value={modalValues?.Contact}
										onChange={handleInputChange}
										name="Contact"
										mask={[
											'(',
											/\d/,
											/\d/,
											/\d/,
											')',
											' ',
											/\d/,
											/\d/,
											/\d/,
											'-',
											/\d/,
											/\d/,
											/\d/,
											/\d/,
										]}
										style={{
											width: '100%',
											borderRadius: '6px',
											height: '40px',
											marginBottom: '8px',
											// marginTop: '8px',
											border: '1.5px solid #DDE6F1',
											padding: '5px 0px 5px 6px',

											outlineColor: '#f3a765',
											boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25) inset',
										}}
									/>
									{errors.Contact && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.Contact}
										</div>
									)}{' '}
									{/* Display validation error */}
								</Grid>
								{/* <Grid item lg={4} xs={4} md={4} sm={4} sx={{ padding: '10px 5px' }}>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										Email
									</InputLabel>
									<TextField
										// value={location?.NPI}
										// onChange={(e) =>
										// 	setLocation((prev) => ({ ...prev, NPI: e.target.value }))
										// }
										name="Email"
										type="email"
										size="small"
										fullWidth
										disableUnderline
										value={'Not Found API'}
										sx={{
											// border: '1px solid #00000026',
											// boxShadow: ' 0px 1px 2px 0px #79ACF178 inset',
											// padding: '6px 3px',
											borderRadius: '4px',
										}}
									/>
								</Grid> */}

								<Grid
									item
									lg={12}
									xs={12}
									md={12}
									sm={12}
									xl={12}
									sx={{ padding: '10px 5px' }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										Address
									</InputLabel>
									<TextField
										name="Address"
										type="text"
										size="small"
										fullWidth
										disableUnderline
										value={modalValues?.Address}
										onChange={targetModalValue}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									/>
								</Grid>
								<Grid
									item
									lg={4}
									xs={4}
									md={4}
									sm={4}
									xl={4}
									sx={{ padding: '10px 5px' }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										City
									</InputLabel>
									<TextField
										name="City"
										type="text"
										size="small"
										fullWidth
										disableUnderline
										value={modalValues?.City}
										onChange={handleInputChange}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									/>
									{errors.City && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.City}
										</div>
									)}{' '}
									{/* Display validation error */}
								</Grid>
								<Grid
									item
									lg={4}
									xs={4}
									md={4}
									sm={4}
									xl={4}
									sx={{ padding: '10px 5px' }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										State
									</InputLabel>
									<TextField
										name="State"
										type="text"
										size="small"
										fullWidth
										disableUnderline
										value={modalValues?.State}
										onChange={handleInputChange}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									/>
									{errors.State && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.State}
										</div>
									)}{' '}
									{/* Display validation error */}
								</Grid>
								<Grid
									item
									lg={4}
									xs={4}
									md={4}
									sm={4}
									xl={4}
									sx={{ padding: '10px 5px' }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										ZIP
									</InputLabel>
									<TextField
										name="Zip"
										type="text"
										size="small"
										fullWidth
										disableUnderline
										value={modalValues?.Zip}
										onChange={handleInputChange}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									/>
									{errors.Zip && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.Zip}
										</div>
									)}{' '}
									{/* Display validation error */}
								</Grid>
								{/* <Grid
									item
									lg={12}
									xs={12}
									md={12}
									sm={12}
									sx={{ padding: '10px 5px' }}
								>
									<InputLabel
										sx={{
											fontFamily: 'Poppins',
											fontSize: '14px',
											fontWeight: '500',
											textAlign: 'left',
											color: 'black',
										}}
									>
										Comments
									</InputLabel>
									<TextField
										name="Comments"
										type="text"
										size="small"
										fullWidth
										disableUnderline
										value={modalValues.Comments}
										onChange={targetModalValue}
										sx={{
											boxShadow: '0px 1px 10px 0px #79ACF178 inset',
											borderRadius: '4px',
										}}
									/>
								</Grid> */}
								<Box
									mt={1}
									width={'100%'}
									height={'70px'}
									display={'flex'}
									justifyContent={'center'}
									gap={2}
								>
									<Button
										onClick={handleCloseModal}
										style={{
											backgroundColor: '#ED2828',
											width: '151px',
											height: '52px',
											borderRadius: '7px',
											color: '#FFFFFF',
											fontSize: '20px',
										}}
									>
										Cancel
									</Button>
									<Button
										disabled={
											errors?.Title ||
											errors?.Fname ||
											errors?.Lname ||
											errors?.City ||
											errors?.Contact ||
											errors?.Specialty ||
											errors?.NPI ||
											errors?.State ||
											errors?.Zip ||
											modalValues.DOB >=
												dayjs(new Date()).format('YYYY-MM-DD') ||
											modalValues.DOB == ''
										}
										style={{
											backgroundColor: `${errors?.Title || errors?.Fname || errors?.Lname || errors?.City || errors?.Contact || errors?.NPI || errors?.State || errors?.Zip || modalValues.DOB >= dayjs(new Date()).format('YYYY-MM-DD') || modalValues.DOB == '' || errors?.Specialty ? 'grey' : '#00A2E8'}`,
											width: '151px',
											height: '52px',
											borderRadius: '7px',
											color: '#FFFFFF',
											fontSize: '20px',
										}}
										onClick={() => updateModalValues(modalValues)}
									>
										Update
									</Button>
								</Box>
							</Grid>
						</Box>
					</Modal>

					{/*Delete Dialog Structure */}

					<Dialog
						fullScreen={fullScreen}
						open={deletePopupOpen}
						onClose={handleDialogClose}
						aria-labelledby="responsive-dialog-title"
						PaperProps={{
							style: { borderRadius: 8, width: '50%' },
						}}
					>
						<DialogTitle
							id="responsive-dialog-title"
							sx={{
								width: '100%',
								height: '80px',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								borderBottom: '1px solid #00000070',
							}}
						>
							<Typography
								width={'85%'}
								textAlign="center"
								sx={{
									fontFamily: 'Poppins',
									fontWeight: '600',
									fontSize: '32px',
								}}
							>
								{' '}
								Delete Staff{' '}
							</Typography>

							<IconButton
								sx={{ width: '5%' }}
								size="small"
								onClick={deleteCancelPopup}
							>
								<CancelIcon color="error" sx={{ fontSize: '30px' }} />
							</IconButton>
						</DialogTitle>
						<DialogContent>
							<Typography
								textAlign="center"
								sx={{
									fontFamily: 'Poppins',
									fontWeight: 400,
									fontSize: '25px',
								}}
							>
								{' '}
								Are you sure to delete this Staff?
							</Typography>
							<Typography
								textAlign="center"
								sx={{
									fontFamily: 'Poppins',
									fontWeight: '600',
									fontSize: '24px',
									color: '#075AD7',
								}}
							>
								{deleteUser} ?
							</Typography>
							<br />
							<Grid container spacing={2} align="center">
								<Grid item xl={6} lg={6} md={6} sm={6} xs={6} align="right">
									<Button
										style={{
											backgroundColor: '#ED2828',
											width: '151px',
											height: '52px',
											borderRadius: '7px',
											color: '#FFFFFF',
											fontSize: '20px',
										}}
										onClick={deleteCancelPopup}
									>
										No
									</Button>
								</Grid>
								<Grid item xl={6} lg={6} md={6} sm={6} xs={6} align="left">
									<Button
										style={{
											backgroundColor: '#00A2E8',
											width: '151px',
											height: '52px',
											borderRadius: '7px',
											color: '#FFFFFF',
											fontSize: '20px',
										}}
										onClick={() => {
											deleteStaff(deleteID, deleteStatus);
										}}
									>
										Yes
									</Button>
								</Grid>
							</Grid>
						</DialogContent>
					</Dialog>

					{/* Show Snackbar After Deletion */}

					<Snackbar
						autoHideDuration={1500}
						open={openSnackbar}
						onClose={handleCloseSnackbar}
						anchorOrigin={{
							vertical: 'center',
							horizontal: 'center',
						}}
					>
						<Alert
							onClose={handleCloseSnackbar}
							severity={severity}
							variant="filled"
							sx={{
								width: '100%',
								height: '4rem',
								textAlign: 'center',
								fontSize: '1.1rem',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
							}}
							action={
								<React.Fragment>
									<span
										onClick={() => {
											handleCloseSnackbar();
										}}
										style={{
											cursor: 'pointer',
											m: 'auto 0',
											fontSize: '16px',
											color: 'rgb(231, 231, 231)',
										}}
									>
										Close
									</span>
								</React.Fragment>
							}
						>
							{severity === 'error'
								? 'Staff Deleted!'
								: 'Staff Updated Successfully !'}
						</Alert>
					</Snackbar>
				</Box>
			)}
		</div>
	);
}

export default ViewStaff;
